import { NgModule } from "@angular/core";
import { TableModule } from "primeng/table";
import { ToolbarModule } from "primeng/toolbar";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { InputTextModule } from "primeng/inputtext";
import { TooltipModule } from "primeng/tooltip";
import { GenericDialogComponent } from "../../shared/generic-dialog/generic-dialog.component";
import { DropdownModule } from "primeng/dropdown";
import { ChipsModule } from "primeng/chips";
import { TabViewModule } from 'primeng/tabview';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { InputNumberModule } from "primeng/inputnumber";
import { FileUploadModule } from "primeng/fileupload";
import { PasswordModule } from "primeng/password";
import { EmpresaComponent } from "./empresa.component";

@NgModule({
  declarations: [
    EmpresaComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    ConfirmDialogModule,
    InputTextModule,
    TooltipModule,
    GenericDialogComponent,
    DropdownModule,
    ChipsModule,
    TabViewModule,
    SpinnerServiceComponent,
    InputNumberModule,
    FileUploadModule,
    PasswordModule,
  ],
})
export class EmpresaModule { }
